import { AppContext } from "App";
import { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ComponentsShowcase from "./components-showcase";
import ITMainPage from "./index";
import TestOdoo from "./test-odoo";

const ITRoutes = () => {
  const { hasPermission } = useContext(AppContext);

  const hasAccess = hasPermission();

  return (
    <Routes>
      <Route index element={<ITMainPage />} />
      <Route
        path="components"
        element={hasAccess ? <ComponentsShowcase /> : <Navigate to="/it" />}
      />
      <Route
        path="test-odoo"
        element={hasAccess ? <TestOdoo /> : <Navigate to="/it" />}
      />
      <Route path="*" element={<Navigate to="/it" replace />} />
    </Routes>
  );
};

export default ITRoutes;
